import { Loan } from '@treasury/domain/loans/loan.entity';
import { TmBaseComponent } from '@treasury/presentation';
import '@treasury/presentation/components/tm-footer';
import { html } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import '../../components/confirmation-container';
import './loan-payment-readonly';

export const tagName = 'loan-confirm-step';
@customElement(tagName)
export class LoanConfirmStep extends TmBaseComponent {
    @property({ type: Object })
    public loan = new Loan();

    protected render() {
        return html`<confirmation-container .headingText=${'Loan Payment Submitted'}>
                <div>
                    <loan-payment-readonly .loan=${this.loan} confirmation></loan-payment-readonly>
                </div>
            </confirmation-container>
            <tm-footer
                .buttonConfig=${[
                    {
                        text: 'Make another loan payment',
                        importance: 'secondary',
                        onClick: () => {
                            this.dispatchEvent(new CustomEvent('start-new-loan'));
                        },
                    },
                    {
                        text: 'View loan activity',
                        importance: 'secondary',
                        onClick: () => {
                            this.dispatchEvent(new CustomEvent('view-loans'));
                        },
                    },
                ]}
            ></tm-footer>`;
    }
}

declare global {
    interface HTMLElementTagNameMap {
        [tagName]: LoanConfirmStep;
    }
}
